import config from '@/config'
import { isNativeMobile } from '@/authenticated/hooks/useIsMobile'

function useOauthParams(referralCode?: string) {
  const isMobileParam = isNativeMobile() ? 'is_mobile=true' : ''
  const referralCodeParam = referralCode ? `referral_code=${referralCode}` : ''
  const params = new URLSearchParams()

  if (isMobileParam) {
    params.append('is_mobile', 'true')
  }

  if (referralCodeParam && referralCode) {
    params.append('referral_code', referralCode)
  }
  return params.toString()
}

export const redirectToGoogleOAuthURL = async (referralCode?: string) => {
  window.location.href = `${
    config.apiGateway.URL
  }/api/oauth/google/url?${useOauthParams(referralCode)}`
}
export const redirectToAppleOAuthURL = async (referralCode?: string) => {
  window.location.href = `${
    config.apiGateway.URL
  }/api/oauth/apple?${useOauthParams(referralCode)}`
}
